import { SelectSearchOption } from '../../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { ServiceGroup } from '../../../mdqx-graphql-types';

export class ServiceGroupEntity implements SelectSearchOption<ServiceGroupEntity> {
    constructor(public Id: number, public Name: string) {}
    get optionLabel() {
        return this.Name;
    }
    static readonly GqlFields: Array<keyof ServiceGroup> = ['id', 'name'];
    static fromBackend(res: ServiceGroup) {
        return new ServiceGroupEntity(res.id, res.name);
    }
}
